export const environment = {
    name: 'prod-euwest1',
    production: true,
    config: {
        server: {
            instructorMarket: 'https://instructors.leapest.com',
            account: 'https://account.leapest.com',
            bouncer: 'https://account.leapest.com',
            sahara: 'https://my.leapest.com',
            sphinx: 'https://downloads.leapest.com',
            intershop: 'https://leapest.com',
            productMarketplace: 'http://products.leapest.com',
            instructorMarketplace: 'https://instructors.leapest.com',
            integrationFramework: 'https://integration.leapest.com',

            url: 'https://amber.leapest.com',
            apiUrl: 'https://amber.leapest.com/api',
            apiSolar: 'https://amber.leapest.com/domain/api',
            apiBazaarGraphql: 'https://amber.leapest.com/api/bazaar/graphql',
            echo: 'https://echo.leapest.com'
        },
        google: {
            url: 'https://accounts.google.com/o/oauth2/v2/auth?',
            authCodeUrl: 'https://www.googleapis.com//oauth2/v4/token?',
            clientId: '271284716197-7pttpjicp5dit3b2jf4emurp2g2kksfp.apps.googleusercontent.com',
            callbackRoute: '/google/callback',
            reCaptchaSiteKey: '6Lc1mskeAAAAAJCD4drIT1XJJ7Vz1-QkvDaBjl7f'
        },
        aws: {
            region: 'eu-west-1',
            key: 'AKIAWLQHGLXHJDK63CJC',
            url: 'https://s3-eu-west-1.amazonaws.com',
            downloadUrl:' https://downloads.leapest.com/proxy/service/jwt',
            uploadsBucket: 'leap-prod-euwest1-uploads',
            cdnBucket: 'leap-prod-euwest1-cdn',
            publicBucket: 'leap-prod-euwest1-public',
            buyerUploadsBucket: 'leap-prod-euwest1-buyer-files',
            sellerProductUploadsBucket: 'leap-prod-euwest1-public-product-images',
            buyerUploadCreditBucket: 'leap-prod-euwest1-buyer-credit',
            pricelistBucket: 'leap-prod-euwest1-pricelist',
            instructorProfileUpload: 'leap-prod-euwest1-instructor-profiles',
            instructorExpenseUpload: 'leap-prod-euwest1-instructor-expenses',
            knowledgeBaseBucket: 'leap-prod-euwest1-knowledge-base',
            sellerUploadsBucket: 'leap-prod-euwest1-seller-uploads',
            productUploadDeliverables: 'leap-prod-euwest1-product-deliverables',
            productUploadBrandingBucket: 'leap-prod-euwest1-product-branding',
            sellerBulkUpload: 'leap-prod-euwest1-umbrella',
            uploadMediaSources: 'leap-prod-euwest1-product-promotional-materials'
        },
        buyers: {
            url: 'https://www.leapest.com/WFS/Store/en_US/-/USD/account',
            faqUrl: 'https://www.leapest.com/WFS/Store/en_US/-/USD/helpdesk/faq',
            shopUrl: 'https://www.leapest.com/WFS/Store/en_US/-/USD/-zid',
            shopUrlNew: 'https://products.leapest.com/products',
            productUrl: 'https://www.leapest.com/WFS/Store/en_US/-/',
            productMarketplace: 'https://products.leapest.com/welcome?leapest-force-login=true'
        },
        stripe: {
            key: 'pk_live_Xy0IFDlXHGpAJrsh9gUcBO1K'
        },
        adyen: {
            publicKey: `
            -----BEGIN PUBLIC KEY-----
            MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCisWT53qlVFdASFLwkvU3yMB4E
            ssq/8yUMI99kBiT04y96Ha6nHndZIt+H+jC0opBUzBNWuZ8xcmih8fZ7sj3nIRGe
            eHoAxKSWZVj4aOUWqP6GJCW0cnN2U93x1SLtKtHVbH3/OAlrWZ0sRAwrXT6ZKSIo
            5q6Gj8c0aqa45jcHSwIDAQAB
            -----END PUBLIC KEY-----
            `
        },
        okta: {
            issuer: 'https://edcast.okta.com/oauth2/ausew5lg3ep73Kkol2p7',
            clientId: '00a-prod-env',
            prefix: 'prod'
        },
        saga: {
          url: 'https://us-api.pxp.csod.com/pxp-configs/v1/ui/sso'
        }
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts